import { db } from '@core/db';
import { WritingVersion } from '@/types';

function nowIso() {
  return new Date().toISOString();
}

export const writingVersionsRepo = {
  async listByProject(projectId: string) {
    return db.writingVersions.where({ projectId }).sortBy('createdAt');
  },
  async get(id: string) { return db.writingVersions.get(id); },
  async create(data: { id: string; projectId: string; name: string; isFinal?: boolean; createdAt?: Date; }) {
    const updatedAt = nowIso();
    const version: WritingVersion = {
      id: data.id,
      projectId: data.projectId,
      name: data.name,
      isFinal: !!data.isFinal,
      createdAt: data.createdAt || new Date(),
      updatedAt,
      dirty: true,
      baseRemoteUpdatedAt: undefined,
      deletedAt: undefined,
    };
    await db.writingVersions.put(version);
    return version;
  },
  async markFinal(id: string) {
    await db.writingVersions.update(id, {
      isFinal: true,
      updatedAt: nowIso(),
      dirty: true,
    });
    return db.writingVersions.get(id);
  },
  async rename(id: string, name: string) {
    await db.writingVersions.update(id, {
      name,
      updatedAt: nowIso(),
      dirty: true,
    });
    return db.writingVersions.get(id);
  },
};
